import React, { Component } from 'react';

import classNames from 'classnames';
import { ChecklistItem } from 'components/checklist';
import { TableCell } from 'components/table';
import PropTypes from 'prop-types';

import DataTableContext from './DataTableContext';

class DataTableSelectItem extends Component {
  // #region set up
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    item: PropTypes.object
  };
  // #end region

  // #region render
  render() {
    const { className, item } = this.props;
    const classComponent = classNames('data-table-select-cell', className);

    return (
      <DataTableContext.Consumer>
        {({ actions }) => (
          <TableCell className={classComponent}>
            <ChecklistItem
              item={{ checked: item._checked }}
              onChange={(event) => actions.onSelectItem(event, item)}
            />
          </TableCell>
        )}
      </DataTableContext.Consumer>
    );
  }
  // #endregion
}

export default DataTableSelectItem;
